import React from 'react';
import ReconciliationCenter from './ReconciliationCenter';

export default function ReconciliationInventory() {
	return <ReconciliationCenter domain="Inventory" />;
}
